"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseYoutubeChannel = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@wix/wix-vod-constants/common");
const common_2 = require("@wix/wix-vod-shared/common");
const get_thumbnail_1 = tslib_1.__importDefault(require("./get-thumbnail"));
function parseYoutubeChannel(urlType, channelData) {
    const { id: externalId, snippet = {}, contentDetails = {}, statistics = {}, brandingSettings = {}, isExternalRemoved = false, } = channelData;
    const { title, description, thumbnails, publishedAt } = snippet;
    const { itemCount, relatedPlaylists = {} } = contentDetails;
    const videosCount = Number(itemCount || statistics.videoCount) || 0;
    const thumbnailUrl = (0, get_thumbnail_1.default)(thumbnails) || null;
    let coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || thumbnailUrl;
    if (urlType === common_1.URL_TYPES.PLAYLIST && videosCount === 0) {
        coverUrl = null;
    }
    return (0, common_2.removeUndefinedValues)({
        externalId,
        uploadsPlaylistId: relatedPlaylists.uploads,
        title,
        description,
        thumbnailUrl,
        coverUrl,
        videosCount,
        externalCreatedTs: new Date(publishedAt),
        channelType: common_1.CHANNEL_TYPES.YOUTUBE_FEED,
        urlType,
        isExternalRemoved,
    });
}
exports.parseYoutubeChannel = parseYoutubeChannel;
//# sourceMappingURL=channel.js.map